// eslint-disable-next-line import/prefer-default-export
export var getHasCheckableItems = function getHasCheckableItems(items) {
  return Boolean(items.find(function (item) {
    return item.type === "checkableItem";
  }));
};